<div style="position: relative; margin: 5px;">

  <div class="search-bar">
    <input type="text" (keyup)="changeSearchKey()" class="search-input" [(ngModel)]="searchKey" placeholder="{{'placeholder.globalSearch' | transloco}}" autofocus autocomplete="off"/>
    <div style="position: absolute; top: 10px; left: 10px;">
      <mat-icon style="font-size: 19px;">search</mat-icon>
    </div>
    @if (searchKey) {
      <div style="position: absolute; top: 12px; right: 40px; cursor: pointer !important; opacity: 0.7;" (click)="clearSearchKey()">
        <mat-icon style="font-size: 16px;" matTooltip="{{'general.clearSearch' | transloco}}">close</mat-icon>
      </div>
    }
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
      <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
    </div>
  </div>

  <div class="pull-right search-text">
    @if (searchResults.length > 0) {
      <span>{{'general.items' | transloco}}: {{ filteredSearchResult.length }} / {{ searchResults.length }}</span>
    }
    @if (searchResults.length == 0) {
      <span>{{'general.noSearchResult' | transloco}}</span>
    }
  </div>

  <div class="search-result" fxLayout="row" style="position: relative;">

    <div fxLayout="column" style="margin-top: 30px; width: 60px;">
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'scene'}" (click)="setSearchFilter('scene')">
          <mat-icon matTooltip="{{'navigation.scenes' | transloco}}">control_camera</mat-icon>
        </a>
      }
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'paint'}" (click)="setSearchFilter('paint')">
          <mat-icon matTooltip="{{'navigation.painter' | transloco}}">color_lens</mat-icon>
        </a>
      }
      <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'player'}" (click)="setSearchFilter('player')">
        <mat-icon matTooltip="{{'navigation.players' | transloco}}">desktop_windows</mat-icon>
      </a>
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'resource'}" (click)="setSearchFilter('resource')">
          <mat-icon matTooltip="{{'navigation.resources' | transloco}}">playlist_play</mat-icon>
        </a>
      }
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'catalog'}" (click)="setSearchFilter('catalog')">
          <mat-icon matTooltip="{{'navigation.catalog' | transloco}}">table_view</mat-icon>
        </a>
      }
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'event'}" (click)="setSearchFilter('event')">
          <mat-icon matTooltip="{{'navigation.events' | transloco}}">access_alarm</mat-icon>
        </a>
      }
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'transition'}" (click)="setSearchFilter('transition')">
          <mat-icon matTooltip="{{'navigation.transitions' | transloco}}">widgets</mat-icon>
        </a>
      }
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'music'}" (click)="setSearchFilter('music')">
          <mat-icon matTooltip="{{'navigation.music' | transloco}}">queue_music</mat-icon>
        </a>
      }
      @if (!dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'scheduler'}" (click)="setSearchFilter('scheduler')">
          <mat-icon matTooltip="{{'navigation.scheduler' | transloco}}">date_range</mat-icon>
        </a>
      }
      <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'product'}" (click)="setSearchFilter('product')">
        <mat-icon matTooltip="{{'navigation.products' | transloco}}">view_comfy</mat-icon>
      </a>
      @if (dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'user'}" (click)="setSearchFilter('user')">
          <mat-icon matTooltip="{{'navigation.users' | transloco}}">supervisor_account</mat-icon>
        </a>
      }
      @if (dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'privilege'}" (click)="setSearchFilter('privilege')">
          <mat-icon matTooltip="{{'navigation.privileges' | transloco}}">check</mat-icon>
        </a>
      }
      @if (dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'app'}" (click)="setSearchFilter('app')">
          <mat-icon matTooltip="{{'navigation.apps' | transloco}}">featured_video</mat-icon>
        </a>
      }
      @if (dashboard) {
        <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'adnet'}" (click)="setSearchFilter('adnet')">
          <mat-icon matTooltip="{{'navigation.adnet' | transloco}}">card_travel</mat-icon>
        </a>
      }
      @if (canShowHelp && showHelp) {
          <a mat-icon-button class="filter-icon mini-button" [ngClass]="{'active': filter == 'help'}" (click)="setSearchFilter('help')">
            <mat-icon matTooltip="{{'navigation.help' | transloco}}">help_outline</mat-icon>
          </a>
      }
    </div>
    <div fxFlex="100%" style="position: relative;">
      <cdk-virtual-scroll-viewport [itemSize]="20" class="search-items">
        <div *cdkVirtualFor="let item of filteredSearchResult" class="search-item-wrapper" (click)="navigateSearchItem(item)">
          @if (!dashboard) {
            <span>
              @switch (item.type) {
                @case ('scene') {
                  <mat-icon>control_camera</mat-icon>
                }
                @case ('slide') {
                  <mat-icon>touch_app</mat-icon>
                }
                @case ('paint') {
                  <mat-icon>color_lens</mat-icon>
                }
                @case ('resource') {
                  <mat-icon>playlist_play</mat-icon>
                }
                @case ('player') {
                  <mat-icon>desktop_windows</mat-icon>
                }
                @case ('catalog') {
                  <mat-icon>table_view</mat-icon>
                }
                @case ('event') {
                  <mat-icon>access_alarm</mat-icon>
                }
                @case ('transition') {
                  <mat-icon>widgets</mat-icon>
                }
                @case ('music') {
                  <mat-icon>queue_music</mat-icon>
                }
                @case ('scheduler') {
                  <mat-icon>date_range</mat-icon>
                }
                @case ('help') {
                  <mat-icon>help_outline</mat-icon>
                }
                @case ('product') {
                  <mat-icon>view_comfy</mat-icon>
                }
              }
            </span>
          }
          @if (dashboard) {
            <span>
              @switch (item.type) {
                @case ('player') {
                  <mat-icon>desktop_windows</mat-icon>
                }
                @case ('music') {
                  <mat-icon>queue_music</mat-icon>
                }
                @case ('help') {
                  <mat-icon>help_outline</mat-icon>
                }
                @case ('product') {
                  <mat-icon>view_comfy</mat-icon>
                }
                @case ('user') {
                  <mat-icon>supervisor_account</mat-icon>
                }
                @case ('privilege') {
                  <mat-icon>check</mat-icon>
                }
                @case ('app') {
                  <mat-icon>featured_video</mat-icon>
                }
                @case ('adnet') {
                  <mat-icon>card_travel</mat-icon>
                }
              }
            </span>
          }

          <span class="name">{{ item.text }}</span>
        </div>
      </cdk-virtual-scroll-viewport>
      <div class="gap-bar top"></div>
      <div class="gap-bar bottom"></div>
    </div>
    @if (this.filter.length > 3) {
      <span style="position: absolute; top: 5px; right: 7px; font-size: 12px;">{{'general.filterSection' | transloco}} selected: {{this.filter}}</span>
    }
  </div>
  @if (isLoading) {
    <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto;">
      <app-loading [size]="'50px'" [style]="{'margin-top': '200px'}"></app-loading>
    </div>
  }
</div>
